import { constants } from '@/constants';
import type { FlowType, SessionSource } from '@/store/SessionStore';
import cookieManager from '../cookieHelper';
import { Page } from './types';

export type DestinationCardSection = 'featured' | 'popular';

export const getClubCode = () => {
  const zipCookie = cookieManager('zipcode');
  if (zipCookie !== null) {
    const clubcode = zipCookie.split('|')[2];
    return clubcode ? clubcode.padStart(3, '0') : '';
  }
  return '';
};

export const getZipCode = () => {
  const zipCookie = cookieManager('zipcode');
  if (zipCookie !== null) {
    const zip = zipCookie.split('|')[0];
    return zip;
  }
  return '';
};

export const isZipCode = (value?: string | null) => /^\d{5}$/.test(value ?? '');

export const deriveFlowTag = (
  sessionSource: SessionSource,
  flowType: FlowType,
): string => {
  if (sessionSource === 'new' && flowType === 'emailInquiry') {
    return 'advisor inquiry';
  }

  if (sessionSource === 'email') {
    return flowType ? `email:${flowType}` : 'email';
  }

  let tag = 'new';

  if (flowType) {
    tag += `:${flowType}`;
  }

  return tag;
};

export const getDestinationCardCta = (
  section: DestinationCardSection,
  destinationName: string,
): string => `${Page.destination}-${section} ${destinationName.toLowerCase()}`;

export const getTrvEndLocationForTagging = ({
  searchedDestination = '',
  userSearch = '',
  selectedDestinationName = '',
  isDestinationFromCard = false,
}: {
  searchedDestination?: string;
  userSearch?: string;
  selectedDestinationName?: string;
  isDestinationFromCard?: boolean;
}): string => {
  if (isDestinationFromCard) {
    return '';
  }

  return searchedDestination || userSearch || selectedDestinationName || '';
};

export const selectTrvEndLocationForTagging = (state: {
  searchedDestination: string;
  userSearch: string;
  selectedDestination: { name: string };
  isDestinationFromCard: boolean;
}): string =>
  getTrvEndLocationForTagging({
    searchedDestination: state.searchedDestination,
    userSearch: state.userSearch,
    selectedDestinationName: state.selectedDestination.name,
    isDestinationFromCard: state.isDestinationFromCard,
  });

export const loadUtagJs = () => {
  if (window.utagLoadAttempt) return;
  window.utagLoadAttempt = true;
  const utagJsScript = document.createElement('script');
  utagJsScript.src = constants.UTAG_SCRIPT_SRC;
  utagJsScript.type = 'text/javascript';
  utagJsScript.async = true;
  document.body.appendChild(utagJsScript);
};
